import { render, staticRenderFns } from "./jinxian.vue?vue&type=template&id=43f73db2&scoped=true&"
import script from "./jinxian.vue?vue&type=script&lang=js&"
export * from "./jinxian.vue?vue&type=script&lang=js&"
import style0 from "./jinxian.vue?vue&type=style&index=0&id=43f73db2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f73db2",
  null
  
)

export default component.exports